import domtoimage from 'dom-to-image';

type PermissionName =
  | 'geolocation'
  | 'notifications'
  | 'persistent-storage'
  | 'push'
  | 'screen-wake-lock'
  | 'xr-spatial-tracking';
type BufferSource = ArrayBufferView | ArrayBuffer;
type BlobPart = BufferSource | Blob | string;

export const snapshotCreator = async (element: any) => {
  try {
    if (!element) {
      throw new Error('Element not found');
    }

    const scale = window.devicePixelRatio;

    const blob = await domtoimage.toBlob(element, {
      height: element.offsetHeight * scale,
      width: element.offsetWidth * scale,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        width: `${element.offsetWidth}px`,
        height: `${element.offsetHeight}px`,
      },
    });

    return blob;
  } catch (error) {
    throw new Error(String(error));
  }
};

export const copyImageToClipBoardSafari = (element: HTMLElement) => {
  navigator.clipboard
    .write([
      new ClipboardItem({
        'image/png': new Promise((resolve, reject) => {
          try {
            const blob = snapshotCreator(element);

            resolve(
              new Blob([blob as unknown as BlobPart], { type: 'image/png' })
            );
          } catch (err) {
            reject(err);
          }
        }),
      }),
    ])
    // eslint-disable-next-line no-console
    .then(() => console.log('Copied to clipboard'))
    .catch((err) => {
      throw new Error(err);
    });
};

export const copyImageToClipBoardOtherBrowsers = (element: HTMLElement) => {
  navigator?.permissions
    ?.query({ name: 'clipboard-write' as PermissionName })
    .then(async (result) => {
      if (result.state === 'granted') {
        const type = 'image/png';
        const blob = await snapshotCreator(element);
        const data = [new ClipboardItem({ [type]: blob as Blob })];

        navigator.clipboard
          .write(data)
          // eslint-disable-next-line no-console
          .then(() => console.log('Copied to clipboard'))
          .catch((err) => {
            throw new Error(err);
          });
      }
    });
};
